import React from 'react';
import classnames from 'classnames';

import { Icon, MaterialHint } from 'shared/components';
import commonFilterTheme from 'modules/queues/common/components/AppointmentsFilter/AppointmentsFilter.scss';
import theme from './FilterIconWithHint.scss';


const FilterIconWithHint = ({ openPopover, popoverOpened, iconName, activeFilters, iconTooltipMessage, lastChild }) => (
  <MaterialHint placement="top" title={ iconTooltipMessage }>
    <button
      className={ classnames(
        theme.root,
        commonFilterTheme.filterIconContainer, {
          [commonFilterTheme.active]: popoverOpened,
          [commonFilterTheme.lastChild]: lastChild,
        },
      ) }
      onClick={ openPopover }
      aria-label={ iconTooltipMessage }
    >
      <Icon name={ iconName } />

      { !!activeFilters.length && (
        <div className={ theme.activeFiltersAmountIcon }>
          { activeFilters.length }
        </div>
      ) }
    </button>
  </MaterialHint>
);

export default FilterIconWithHint;
